import NewsletterSeventeenContainer from "./containers/NewsletterSeventeenContainer";
export default NewsletterSeventeenContainer;
